import { useQuery } from "@tanstack/react-query";
import { listTeachers } from "@/api/teachers.api";
import { queryKeys } from "@/constants/queryKeys";
import { useAuthStore } from "@/store/auth.store";

export function useTeachers() {
  const { schoolId } = useAuthStore();

  const q = useQuery({
    queryKey: queryKeys.teachers(schoolId),
    queryFn: () => listTeachers(schoolId!),
    enabled: !!schoolId,
    retry: 1,
  });

  return {
    data: q.data ?? [],
    isLoading: q.isLoading,
    error: q.error,
    refetch: q.refetch,
  };
}
